
export const clearWithdrawal = ({commit}) => {
    commit('setWithdrawalPending', false);
    commit('setWithdrawalComplete', false);

    commit('setWithdrawalError', null);
    commit('setWithdrawal', {});
};
